import { render, staticRenderFns } from "./Comanda.vue?vue&type=template&id=1fd4db48&scoped=true&"
import script from "./Comanda.vue?vue&type=script&lang=js&"
export * from "./Comanda.vue?vue&type=script&lang=js&"
import style0 from "./Comanda.vue?vue&type=style&index=0&id=1fd4db48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd4db48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCardText,VDivider,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep,VSwitch})
